// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_adding_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Adding to Cart...`
};

const el_adding_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Προσθήκη...`
};

const ru_adding_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Добавляем...`
};

const he_adding_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `מוסיף...`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const adding_to_cart = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.adding_to_cart(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("adding_to_cart", locale)
	if (locale === "en") return en_adding_to_cart(inputs)
	if (locale === "el") return el_adding_to_cart(inputs)
	if (locale === "ru") return ru_adding_to_cart(inputs)
	if (locale === "he") return he_adding_to_cart(inputs)
	return "adding_to_cart"
};